/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meetings_Exception_FailedInputs */



/**
* | output |
* | --- |
* | "That could not be switched off. Check the address and try again." |
*
* @param {Meetings_Exception_FailedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meetings_exception_failed = /** @type {((inputs?: Meetings_Exception_FailedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meetings_Exception_FailedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Dat kon niet uitgezet worden. Kijk het adres na en probeer opnieuw.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cela n'a pas pu être désactivé. Vérifiez l'adresse et réessayez.")
	return /** @type {LocalizedString} */ ("That could not be switched off. Check the address and try again.")
});